import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import loadable from '@loadable/component';
import PropTypes from 'prop-types';
import Loading from 'Components/Loading';
import ApplicationLayout from 'Components/ApplicationLayout';
import pMinDelay from 'p-min-delay';
import TicketDetail from './RaffleTickets/TicketDetail';
import { getDraws, getTicketCount } from 'Store/actions/chanceGames/drawsActions';
import { closeModal } from 'Store/actions';
import RenderActiveModals from './Modals/RenderActiveModals';
import ToogleSeoText from 'Components/ToogleSeoText';
import EnvironmentManager from 'Utils/environmentManager';
import LottieLoader from 'Components/LottieLoader';
import { unslugTurkish } from 'Utils/slugTurkish';
import axios from 'axios';
import { catchTJKError } from 'Utils/catchTJKError';
import ProjectConfig from 'ProjectConfig';
import Contract from 'Components/Modal/Contract';
import Modal from 'Components/Modal';
import History from 'Store/history';

const CommunicationPermissions = loadable(() => pMinDelay(import('./CommunicationPermissions'), 300), {
  fallback: <Loading/>
});

const RafflesList = loadable(() => pMinDelay(import('./RafflesList'), 300), {
  fallback: <Loading/>
});

const RaffleDetail = loadable(() => pMinDelay(import('./RaffleDetail'), 300), {
  fallback: <Loading/>
});


const AsyncRaffleLayout = props => {
  const API_GATEWAY = ProjectConfig.API_GATEWAY;
  const { page } = props;
  const historyPath = props.history.location.pathname;
  const locationPath = props.location.pathname;
  const mainTitle = historyPath ? props?.metaConfiguration[historyPath]?.title : props?.metaConfiguration[locationPath]?.title;
  const mainDesc = historyPath ? props?.metaConfiguration[historyPath]?.description : props?.metaConfiguration[locationPath]?.description;
  const mainTitleResult = mainTitle ? mainTitle : 'Şans Oyunları | Eşya Piyangosu - Bilyoner';
  const mainDescResult = mainDesc ? mainDesc : 'Şans Oyunları | Eşya Piyangosu - Bilyoner';

  const pageConfig = {
    headerType: 'full',
    footerType: props.userAgent.device?.type === 'desktop' ? 'full' : 'mobile-none',
    navigationType: 'horse-racing',
    helmet: {
      bodyAttributes: {
        class: `${props.userAgent.device?.type} ${page !== 'bilet-detay' ? 'bg-white' : 'bg-grey'} hide-betslip hide-sticky-navigation`
      },
      title: props?.page === 'detay' ? `${unslugTurkish(props.match.params.raffleName)}` + ' Çekilişi - Bilyoner' : mainTitleResult,
      meta: [{
        name: 'title',
        content: props?.page === 'detay' ? `${unslugTurkish(props.match.params.raffleName)}` + ' Çekilişi - Bilyoner' : mainTitleResult,

      },
      {
        name: 'description',
        content: props?.page === 'detay' ? `${unslugTurkish(props.match.params.raffleName)}` + ' çekilişine katılmak, çekiliş heyecanını Bilyoner ile yaşamak ve kazanmak için hemen tıklayın!' : mainDescResult,
      },
      {
        property: 'og:description',
        content: props?.page === 'detay' ? `${unslugTurkish(props.match.params.raffleName)}` + ' çekilişine katılmak, çekiliş heyecanını Bilyoner ile yaşamak ve kazanmak için hemen tıklayın!' : mainDescResult,
      }]
    }
  };
  const dispatch = useDispatch();
  const [activeRafflesList, setActiveRaffles] = useState([]);
  const [passiveRafflesList, setPassiveRaffles] = useState([]);
  const [rafflesFlag, setRafflesFlag] = useState(false);
  const [errorFlag, setErrorFlag] = useState();
  let pageContent = null;
  const [ticketCounts, setTicketCounts] = useState();
  const modalData = useSelector(state => state.modalData);
  const seoTextHome = EnvironmentManager.getMessageText({ key: 'description_raffle_seo_home' });
  const auth = useSelector(state => state.auth);
  const [loading, setLoading] = useState(true);
  const [contractContent, setContractContent] = useState(null);
  const [otherGames, setOtherGames] = useState([]);


  setTimeout(() => {
    setLoading(false);
  }, 1500);

  const {
    isAuthenticated,
  } = useSelector(state => state.auth);

  const getContract = contractType => {
    axios.get(`${API_GATEWAY}/contract/content/${contractType}`).then(response => {
      catchTJKError(response?.data);
      setContractContent(response?.data?.body);
    });
  };

  const checkContract = async slug => {
    try {
      const res = await axios.get(`${API_GATEWAY}/igames/dg/get/${slug}`);
      catchTJKError(res?.data);
      const { contractType, showContract, games } = res?.data?.body;
      if (showContract) {
        getContract(contractType);
      }
      if (games) {
        setOtherGames(games);
      }
      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (props.location.pathname.includes('esya-piyangosu') && isAuthenticated) {
      checkContract('esya-piyangosu');
    }
  }, [props?.location?.pathname, isAuthenticated]);


  useEffect(() => {
    if (page === 'cekilis') {
      dispatch(getDraws('ALL', 'RAFFLE')).then(res => {
        setActiveRaffles(res?.body?.draws?.ACTIVE);
        setPassiveRaffles(res?.body?.draws?.PASSIVE);
        setRafflesFlag(true);
        setErrorFlag(res?.error);

        if (auth?.data?.accessToken && res?.body?.draws?.PASSIVE.length > 0) {
          const drawIds = res?.body?.draws?.PASSIVE.map(item => item.drawId);
          const requestBody = {
            drawIds: drawIds
          };
          dispatch(getTicketCount(requestBody)).then(res => {
            if (res && Object.keys(res?.body?.ticketCounts).length === 0)
              setTicketCounts(null);
            else
              setTicketCounts(res?.body?.ticketCounts);
          });
        }
      });
    }
  }, []);


  switch (page) {

    case 'iletisim-izinleri':
      pageContent = <CommunicationPermissions { ...props } />;
      break;
    case 'cekilis':
      pageContent = rafflesFlag
        ? <RafflesList { ...props } ticketCounts={ ticketCounts } activeRafflesList={ activeRafflesList } games={ otherGames }
          passiveRafflesList={ passiveRafflesList } errorFlag={ errorFlag }/>
        : <ToogleSeoText text={ seoTextHome } rootExtraClass="events-container__seo__raffle"/>;
      break;
    case 'detay':
      pageContent = <RaffleDetail { ...props } />;
      break;
    case 'bilet-detay':
      pageContent = <TicketDetail { ...props } />;
      break;

    default:
      break;
  }

  const isModalOpen = modalNameRequest => {
    const { modalNames } = modalData;
    return modalNames.some(modalName => modalName === modalNameRequest);
  };

  function closeModalFunc (modalName) {
    dispatch(closeModal(modalName));
  }


  return (
    <ApplicationLayout { ...pageConfig } { ...props } >
      { loading && (
        <div className="tjk-loader">
          <LottieLoader type="loading" loop={ true } autoplay width="75px"/>
        </div>
      ) }
      { pageContent }
      <RenderActiveModals
        modalData={ modalData }
        isModalOpen={ isModalOpen }
        closeModal={ name => {
          closeModalFunc(name);
        } }
      />
      <Modal
        isOpen={ contractContent }
        title={ contractContent?.title }
        closeIconVisible={ false }
        maxHeight='calc(100vh - 112px)'
        onOverlayClick={ () => History.push('/sans-oyunlari') }
        buttonArea={ {
          primaryButton: contractContent?.contractType === 'DIGITAL_GAMES_CALL_CENTER' ? null : {
            onClick: () => {
              axios.post('/contractAcception/save', { contractTypeDatasrvEnum: contractContent?.contractType }).then(response => {
                if (response?.data?.success) {
                  setContractContent(null);
                  checkContract('esya-piyangosu');
                }
              });
            },
            label: 'ONAYLA',
          },
          secondaryButton: {
            variant: 'secondary',
            onClick: () => {
              History.push('/sans-oyunlari');
            },
            label: contractContent?.contractType === 'DIGITAL_GAMES_CALL_CENTER' ? 'TAMAM' : 'VAZGEÇ',
          }
        } }
        onClose={ () => History.push('/sans-oyunlari') }>
        <Contract>{ contractContent?.content }</Contract>
      </Modal>
    </ApplicationLayout>
  );
};

AsyncRaffleLayout.propTypes = {
  userAgent: PropTypes.object,
  history: PropTypes.object,
  match: PropTypes.object,
  location: PropTypes.object,
  page: PropTypes.string,
  metaConfiguration: PropTypes.object
};

export default AsyncRaffleLayout;
